import React from 'react';
import { bool, shape, string } from 'prop-types';

const Transport = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="22" height="15" viewBox="0 0 22 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M0 2.14284C0 0.96428 0.99 0 2.2 0H15.4V3.21427H18.7L22 7.49995V11.7856H19.8C19.8 13.5642 18.326 14.9999 16.5 14.9999C14.674 14.9999 13.2 13.5642 13.2 11.7856H8.8C8.8 13.5642 7.326 14.9999 5.5 14.9999C3.674 14.9999 2.2 13.5642 2.2 11.7856H0V2.14284ZM20.1122 8.16122L17.7246 5.08507H15.4V8.75427C15.7441 8.63583 16.1143 8.57137 16.5 8.57137C17.4774 8.57137 18.3555 8.98521 18.9597 9.6428H20.1122V8.16122ZM5.5 12.8571C4.895 12.8571 4.4 12.3749 4.4 11.7856C4.4 11.1964 4.895 10.7142 5.5 10.7142C6.105 10.7142 6.6 11.1964 6.6 11.7856C6.6 12.3749 6.105 12.8571 5.5 12.8571ZM5.5 8.57137C6.479 8.57137 7.337 8.98923 7.942 9.6428H13.2V2.14284H2.2V9.6428H3.058C3.663 8.98923 4.521 8.57137 5.5 8.57137ZM16.5 12.8571C15.895 12.8571 15.4 12.3749 15.4 11.7856C15.4 11.1964 15.895 10.7142 16.5 10.7142C17.105 10.7142 17.6 11.1964 17.6 11.7856C17.6 12.3749 17.105 12.8571 16.5 12.8571Z" fill="currentColor" />
  </svg>
);

Transport.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default Transport;
